// extracted by mini-css-extract-plugin
module.exports = {"careerWrapper":"compare_careerWrapper__XOHhX","crum":"compare_crum__KfcVj","crumbox":"compare_crumbox__uV6As"};